import { Injectable } from '@angular/core'
import { SystemManagerService } from '../models/system-manager.service'
import {
    generateUpdatedSystemRecords,
    ResponseRecordEntities,
    ResponseSchema,
    Schema,
    TableModel,
    View,
    generateRecords,
} from '../models'
import { ViewFacadeService } from './store-facade/view-facade.service'

@Injectable({
    providedIn: 'root',
})
export class ViewManagerService implements SystemManagerService<View> {
    constructor(private viewFacadeService: ViewFacadeService) {}

    initSystemRecord(
        schema: ResponseSchema,
        record: ResponseRecordEntities,
        selectedSystemRecordGuid?: string,
    ): void {
        const views: View[] = generateRecords(schema, record) as View[]
        this.viewFacadeService.initViews(views, selectedSystemRecordGuid)
        this.viewFacadeService.viewsAreLoaded()
    }

    updateRecord(table: TableModel, schema: Schema): void {
        if (table.deleted) {
            this.viewFacadeService.deleteViews(table.deleted!)
        }

        if (table.updated) {
            const views = generateUpdatedSystemRecords<View>(table, schema)
            this.viewFacadeService.updateViews(views)
        }

        if (table.added) {
            this.viewFacadeService.addViews(generateRecords(schema, table.added) as View[])
        }
    }
}
